import {
  Dialog,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from "@mui/material";

import { i18n } from "services/i18nService";

import { useInactivityTimeout } from "hooks/useInactivityTimeout";

export function Timeout() {
  const { timeoutWarning, handleLogout, stay } = useInactivityTimeout();

  return (
    <Dialog open={timeoutWarning} onClose={stay}>
      <Box m={2}>
        <DialogContentText>{i18n("login.TimeoutMessage")}</DialogContentText>
        <DialogActions>
          <Button onClick={handleLogout} variant="contained">
            {i18n("login.Logout")}
          </Button>
          <Button onClick={stay} variant="contained" autoFocus>
            {i18n("login.Stay")}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
